module.exports = {"particles":{"number":{"value":50,"density":{"enable":false,"value_area":10}},"line_linked":{"enable":true,"distance":120,"color":"#fff","opacity":0.8,"width":1},"move":{"enable":true,"speed":0.6,"direction":"none","random":false,"straight":false,"out_mode":"out"}}}


//////////////////
// WEBPACK FOOTER
// ./src/components/CopperCoastParticles/config.json
// module id = 284
// module chunks = 0